import { useTranslation } from "react-i18next";
import { LOG_TEMPLATES, LogKey } from "@/constants/log-templates.constants";
import type boLogs from "@/locales/fr/boLogs.json";

type LogEntityType =
  Extract<keyof typeof boLogs, `entities.${string}`> extends `entities.${infer T}` ? T : never;

const isLogKey = (action: string): action is LogKey => action in LOG_TEMPLATES;

/**
 * Textes traduits des templates de logs, à partir de leur clé (`boLogs:templates.<LogKey>.*`) et du type d'entité
 * (`boLogs:entities.<entityType>`). Une action ou un type d'entité inconnu est renvoyé tel quel.
 */
export const useLogTemplateTexts = () => {
  const { t, i18n } = useTranslation("boLogs");

  const getTitle = (action: string): string =>
    isLogKey(action) ? t(`templates.${action}.title`) : action;

  const getDescription = (action: string): string | undefined =>
    isLogKey(action) ? t(`templates.${action}.description`) : undefined;

  const getEntityLabel = (entityType: string): string =>
    i18n.exists(`boLogs:entities.${entityType}`)
      ? t(`entities.${entityType as LogEntityType}`)
      : entityType;

  return { getTitle, getDescription, getEntityLabel };
};
